import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import classNames from 'classnames';

const SidenavGroupItem = /*#__PURE__*/ forwardRef(({ active = false, children, className, ...props }, ref)=>{
    return jsx("a", {
        ref: ref,
        className: classNames('cb-sidenav-group-item', className, {
            active
        }),
        title: children,
        ...props,
        children: jsx("span", {
            className: "inner",
            children: children
        })
    });
});
SidenavGroupItem.displayName = 'Sidenav.Group.Item';

export { SidenavGroupItem };
//# sourceMappingURL=Sidenav.Group.Item.es.js.map
